import { render, staticRenderFns } from "./VariationPrismic.vue?vue&type=template&id=28046c4e&"
import script from "./VariationPrismic.vue?vue&type=script&lang=js&"
export * from "./VariationPrismic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports